module.exports = __webpack_public_path__ + "static/assets/297e9d1b4518ccb4081a6dbd26e25f21.svg";